import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { HeartHandshake, HandHeart, Wallet, Handshake, Users } from "lucide-react";

function ParticipateForm({ kind, label, testId }) {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { ...form, kind });
      toast.success("Messaggio inviato! Ti ricontattiamo presto.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Errore invio"); }
    finally { setLoading(false); }
  };
  const input = "w-full rounded-xl bg-white border border-[#292522]/12 px-4 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm";
  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`form-${testId}`}>
      <div className="grid sm:grid-cols-2 gap-3">
        <input required placeholder="Nome" className={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid={`${testId}-name`} />
        <input required type="email" placeholder="Email" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid={`${testId}-email`} />
      </div>
      <textarea required rows="4" placeholder="Raccontaci qualcosa di te…" className={input + " resize-none"} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid={`${testId}-message`} />
      <button disabled={loading} type="submit" className="btn-primary" data-testid={`${testId}-submit`}>{loading ? "Invio…" : label}</button>
    </form>
  );
}

export default function Partecipa() {
  return (
    <div data-testid="partecipa-page">
      <section className="bg-[#FFF1E8] py-16">
        <div className="container-vv">
          <div className="eyebrow">Partecipa</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl tracking-tight text-[#292522]">Metti radici in Vola Vola</h1>
          <p className="mt-4 text-lg text-[#292522]/75 max-w-3xl">Quattro modi per esserci: socio/a, volontariato, sostegno, collaborazione. Scegli quello che ti somiglia di più.</p>
        </div>
      </section>

      <section id="partecipa-evento" className="container-vv py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-5"><Users className="h-7 w-7" strokeWidth={1.5} /></div>
            <div className="eyebrow">01 · Vieni a un evento</div>
            <h2 className="mt-2 font-display font-medium text-4xl">Partecipa a un evento</h2>
            <p className="mt-4 text-[#292522]/75">Il modo più semplice per conoscerci: presentati a uno dei nostri eventi. La partecipazione è quasi sempre gratuita e su iscrizione.</p>
          </div>
          <div className="lg:col-span-7 card-vv p-8 bg-[#F8F1E8] flex flex-col justify-center">
            <p className="text-[#292522]/80 text-lg">Scopri il calendario aggiornato con laboratori, camminate, gruppi di parola e feste di comunità.</p>
            <Link to="/eventi" className="btn-primary mt-6 self-start" data-testid="partecipa-eventi-btn">Vai al calendario eventi</Link>
          </div>
        </div>
      </section>

      <section id="socio" className="container-vv py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-5"><HeartHandshake className="h-7 w-7" strokeWidth={1.5} /></div>
            <div className="eyebrow">01</div>
            <h2 className="mt-2 font-display font-medium text-4xl">Diventa socio/a</h2>
            <p className="mt-4 text-[#292522]/75">Iscriviti all'associazione: partecipi alle assemblee, hai accesso a tutte le attività, contribuisci con la tua voce. Il tesseramento annuale è la spina dorsale della nostra vita associativa.</p>
            <p className="mt-3 text-sm text-[#292522]/60 italic">Quota annuale — <span className="bg-[#FFF1E8] px-1 rounded">DA DEFINIRE</span></p>
          </div>
          <div className="lg:col-span-7 card-vv p-8 bg-[#F8F1E8]">
            <h3 className="font-display text-2xl font-medium mb-4">Voglio associarmi</h3>
            <ParticipateForm kind="socio" label="Invia richiesta" testId="socio" />
          </div>
        </div>
      </section>

      <section id="volontariato" className="bg-[#F8F1E8] py-20">
        <div className="container-vv grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-5"><HandHeart className="h-7 w-7" strokeWidth={1.5} /></div>
            <div className="eyebrow">02</div>
            <h2 className="mt-2 font-display font-medium text-4xl">Fai volontariato con noi</h2>
            <p className="mt-4 text-[#292522]/75">Un pomeriggio al mese, un evento all'anno, un progetto tuo: c'è spazio per tempi e disponibilità diverse. Cerchiamo persone, non specialisti.</p>
          </div>
          <div className="lg:col-span-7 card-vv p-8 bg-white">
            <h3 className="font-display text-2xl font-medium mb-4">Candidatura volontariato</h3>
            <ParticipateForm kind="volontario" label="Candidati" testId="volontario" />
          </div>
        </div>
      </section>

      <section id="cinquepermille" className="bg-[#FFF1E8] py-20 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-72 h-72 blob bg-[#FF6100]/15 pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-80 h-80 blob-2 bg-[#216B65]/10 pointer-events-none" />
        <div className="container-vv relative grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-[#FF6100] tracking-wider uppercase">
              <span className="h-1.5 w-1.5 rounded-full bg-[#FF6100]" /> Dichiarazione dei redditi
            </div>
            <h2 className="mt-5 font-display font-medium text-5xl sm:text-6xl leading-[1] tracking-tight text-[#292522]">
              Metti la <span className="text-[#FF6100]">tua firma</span><br />sulla nostra comunità.
            </h2>
            <p className="mt-6 text-lg text-[#292522]/80 leading-relaxed max-w-xl">
              Con il <strong>5×1000</strong> puoi sostenerci senza spendere nulla: destinaci una piccola quota della tua IRPEF, che altrimenti resterebbe allo Stato. Per te è gratuito, per noi è ossigeno per progetti gratuiti sul territorio.
            </p>
            <div className="mt-8 rounded-3xl bg-white p-6 sm:p-8 shadow-[0_8px_32px_rgba(41,37,34,0.08)]">
              <div className="text-xs uppercase tracking-wider text-[#292522]/50 font-semibold">Come fare</div>
              <ol className="mt-3 space-y-3 text-[#292522]/85">
                <li className="flex gap-3"><span className="shrink-0 h-6 w-6 rounded-full bg-[#FF6100] text-white text-xs font-bold flex items-center justify-center">1</span>Nella tua dichiarazione dei redditi (730, Redditi PF o CU), trova il riquadro <strong>"Scelta per la destinazione del 5×1000"</strong></li>
                <li className="flex gap-3"><span className="shrink-0 h-6 w-6 rounded-full bg-[#FF6100] text-white text-xs font-bold flex items-center justify-center">2</span>Firma nel box <strong>"Sostegno degli enti del Terzo Settore iscritti al RUNTS"</strong></li>
                <li className="flex gap-3"><span className="shrink-0 h-6 w-6 rounded-full bg-[#FF6100] text-white text-xs font-bold flex items-center justify-center">3</span>Scrivi il nostro Codice Fiscale nell'apposito spazio</li>
              </ol>
              <div className="mt-6 pt-6 border-t border-[#292522]/8">
                <div className="text-xs uppercase tracking-wider text-[#292522]/50 font-semibold mb-2">Il nostro Codice Fiscale</div>
                <div className="flex flex-wrap items-center gap-3">
                  <code className="text-2xl sm:text-3xl font-display font-medium text-[#FF6100] tracking-widest select-all" data-testid="cf-5x1000">91436320377</code>
                  <button
                    onClick={() => { navigator.clipboard.writeText("91436320377"); }}
                    className="btn-ghost text-xs"
                    data-testid="copy-cf"
                  >
                    Copia codice fiscale
                  </button>
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-[#292522]/60 italic">
              Puoi destinare il 5×1000 anche se non paghi imposte: non ti costa nulla e non è alternativo all'8×1000 o al 2×1000.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative rounded-[2rem] overflow-hidden bg-[#292522] text-[#FFFCF8] p-10 aspect-square flex flex-col justify-between">
              <div className="absolute -top-16 -right-16 w-56 h-56 blob bg-[#FF6100]/30 pointer-events-none" />
              <div className="relative">
                <div className="text-[10rem] leading-none font-display font-medium text-[#FF6100]">5</div>
                <div className="text-2xl font-display -mt-6">per mille</div>
                <div className="mt-4 text-[#FFFCF8]/60 text-sm">firmato per Vola Vola APS</div>
              </div>
              <div className="relative">
                <div className="text-xs uppercase tracking-wider text-[#FFFCF8]/40 font-semibold">Codice fiscale</div>
                <div className="mt-1 text-2xl font-mono tracking-widest">91436320377</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="sostieni" className="container-vv py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-5"><Wallet className="h-7 w-7" strokeWidth={1.5} /></div>
            <div className="eyebrow">03</div>
            <h2 className="mt-2 font-display font-medium text-4xl">Sostieni Vola Vola</h2>
            <p className="mt-4 text-[#292522]/75">Ogni donazione ci aiuta a portare avanti attività gratuite e progetti di territorio. Puoi contribuire come preferisci:</p>
          </div>
          <div className="lg:col-span-7 grid gap-4 sm:grid-cols-3">
            <div className="card-vv p-6 bg-[#FFF1E8]">
              <h4 className="font-display text-xl font-medium text-[#FF6100]">Bonifico</h4>
              <p className="mt-2 text-sm text-[#292522]/85 leading-relaxed">
                Intestato a <strong>Vola Vola APS</strong><br />
                <span className="font-mono text-xs mt-1 inline-block break-all select-all">IT57 N050 1802 4000 0001 7101 056</span><br />
                <span className="text-xs text-[#292522]/55">Causale: erogazione liberale — Vola Vola APS</span>
              </p>
            </div>
            <div className="card-vv p-6 bg-white">
              <h4 className="font-display text-xl font-medium text-[#FF6100]">PayPal</h4>
              <p className="mt-2 text-sm text-[#292522]/70">paypal.me/<span className="italic">volavolaaps</span><br /><span className="text-xs text-[#292522]/50">Link — DA CONFERMARE</span></p>
            </div>
            <div className="card-vv p-6 bg-[#FFF1E8]">
              <h4 className="font-display text-xl font-medium text-[#FF6100]">Satispay</h4>
              <p className="mt-2 text-sm text-[#292522]/70">Cerca Vola Vola APS<br /><span className="text-xs text-[#292522]/50">Handle — DA CONFERMARE</span></p>
            </div>
          </div>
        </div>
      </section>

      <section id="collabora" className="bg-[#292522] text-[#FFFCF8] py-20">
        <div className="container-vv grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/20 flex items-center justify-center text-[#FF6100] mb-5"><Handshake className="h-7 w-7" strokeWidth={1.5} /></div>
            <div className="eyebrow text-[#FF6100]">04</div>
            <h2 className="mt-2 font-display font-medium text-4xl">Proponi una collaborazione</h2>
            <p className="mt-4 text-[#FFFCF8]/70">Sei una scuola, un'associazione, un ente, un/una professionista? Raccontaci la tua idea: le cose migliori nascono in rete.</p>
          </div>
          <div className="lg:col-span-7 rounded-3xl bg-[#FFFCF8] text-[#292522] p-8">
            <h3 className="font-display text-2xl font-medium mb-4">Contatto per collaborazioni</h3>
            <ParticipateForm kind="collaborazione" label="Invia proposta" testId="collab" />
          </div>
        </div>
      </section>
    </div>
  );
}
